import classnames from 'classnames';
import React, { memo, useCallback } from 'react';
import Icon from '../../utils/Icon';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
import styles from './Dropdown.scss';
const DropdownItem = ({ label = '', icon, iconSrc, iconType, hasStrike = false, data, isSelected = false, isStrikeAction = false, className = '', id, iconClassName, onClose, hoverTitle, onClick, disabled, item, isCLoseOnClick = true, isPreventDefault = true, linkClassName, dataCy, }) => {
    const resolvedTooltipTitle = useHelpNoteTitle(hoverTitle || label || '');
    const handleClick = useCallback(event => {
        isPreventDefault && event.preventDefault();
        event.stopPropagation();
        const argument = isStrikeAction ? id : data;
        onClick && onClick(argument);
        isCLoseOnClick && onClose && onClose();
    }, [
        isPreventDefault,
        onClose,
        onClick,
        isStrikeAction,
        data,
        id,
        isCLoseOnClick,
    ]);
    return (<>
      <li className={classnames(className, {
        active: isSelected,
        disabled,
    })}>
        <a className={classnames(linkClassName, styles.itemLink)} data-cy={dataCy} title={resolvedTooltipTitle} onClick={disabled ? undefined : handleClick}>
          <Icon className={iconClassName} name={icon} src={iconSrc} type={iconType}/>
          {item || label}
        </a>
      </li>
      {hasStrike && <li className="divider"/>}
    </>);
};
export default memo(DropdownItem);
